import html2canvas from 'html2canvas'
import { jsPDF } from "jspdf"
import moment from 'moment'
import fetch from '@/utils/request'
import { message } from 'antd'

const generateAndUploadPdf = (dom, docId, taskableType, fetchUrl) => {
  html2canvas(dom)
    .then((canvas) => {
      var contentWidth = canvas.width
      var contentHeight = canvas.height
      //一页pdf显示html页面生成的canvas高度
      var pageHeight = contentWidth / 592.28 * 841.89
      //  var pageHeight = contentHeight
      //未生成pdf的html页面高度
      var leftHeight = contentHeight
      //页面偏移
      var position = 0
      //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
      var imgWidth = 595.28
      var imgHeight = 592.28 / contentWidth * contentHeight

      var pageData = canvas.toDataURL('image/jpeg', 1.0)

      var pdf = new jsPDF('', 'pt')

      //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
      //当内容未超过pdf一页显示的范围，无需分页
      if (leftHeight < pageHeight) {
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
      } else {
        while (leftHeight > 0) {
          pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
          leftHeight -= contentHeight
          position -= 841.89
          //避免添加空白页
          if (leftHeight > 0) {
            pdf.addPage()
          }
        }
      }
      const blob = pdf.output('blob')
      // 生成pdf后上传
      const formData = new FormData()
      formData.append('file', blob, `${docId}.pdf`)
      fetch(`${fetchUrl}${taskableType}/${docId}`, { method: 'post', body: formData })
        .then((result) => {
          const { code } = result
          if (code === 0) {
            fetch(`/apis/custom_serve_report/period_evaluate_report/share/${taskableType}/${docId}/true`, { method: 'get' })
              .then(() => {
                message.success('分享成功')
              })
          }
        })

    })
}
export default generateAndUploadPdf
